import { useLayoutEffect } from "react";
import { startLabRuntime } from "../labRuntime";
import { LabBody } from "./LabBody";
import { GoToModal } from "./GoToModal";
import { GenerateNotesModal } from "./GenerateNotesModal";
import { HelpModal } from "./HelpModal";
import { MixerModal } from "./MixerModal";
import { PerformanceModal } from "./PerformanceModal";
import { SettingsModal } from "./SettingsModal";
import { BindingEditorModal } from "./BindingEditorModal";
import { RowLabelModal } from "./RowLabelModal";
import { TrackLabelModal } from "./TrackLabelModal";
import { DrumAuthorModal } from "./DrumAuthorModal";
import { SamplerAuthorModal } from "./SamplerAuthorModal";
import { SynthAuthorModal } from "./SynthAuthorModal";
import { WavetableAuthorModal } from "./WavetableAuthorModal";
import { TransportToolbar } from "./TransportToolbar";

/** React lab chrome. Toolbar may re-render; LabBody is frozen after mount. */
export function LabShell() {
  useLayoutEffect(() => {
    // TrackerGrid registers in its child layout effect first, then we start.
    const runtime = startLabRuntime();
    return () => runtime.dispose();
  }, []);

  return (
    <div
      className="lab-shell flex h-dvh min-h-dvh flex-col overflow-hidden overscroll-x-none"
      id="lab-shell"
    >
      <TransportToolbar />
      <LabBody />
      <HelpModal />
      <GoToModal />
      <GenerateNotesModal />
      <MixerModal />
      <PerformanceModal />
      <SettingsModal />
      <BindingEditorModal />
      <RowLabelModal />
      <TrackLabelModal />
      <SynthAuthorModal />
      <DrumAuthorModal />
      <WavetableAuthorModal />
      <SamplerAuthorModal />
    </div>
  );
}
